export default __webpack_public_path__ + "static/media/alert.52d39672.mp3";